import { useLang } from '../context/LanguageContext';

// Convenience hook — provides t(), lang, isRTL, toggleLang in one shot
const useTranslation = () => {
  const { t, lang, isRTL, toggleLang, loading } = useLang();
  return { t, lang, isRTL, toggleLang, loading };
};

export default useTranslation;
